import React, { Fragment } from "react";
// import PropTypes from "prop-types";
import styled from "styled-components";

import { PowerMove } from "./components/power-move";
import { thankYouElement } from "./elements/thank-you";
import { Section, sectionPaddingCss, sectionViewCss } from "./styles";

const StyledSection = styled.section`
  ${sectionPaddingCss}
`;

const SectionView = styled.div`
  ${sectionViewCss}
`;

export function Success(/* props */) {
  return (
    <Fragment>
      <PowerMove />
      <StyledSection>
        <SectionView>
          <Section as="div" id={"thankYou"}>
            {thankYouElement}
          </Section>
        </SectionView>
      </StyledSection>
    </Fragment>
  );
}

Success.propTypes = {};
